import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { Increments, useValidateOnChange } from 'components/event_type_edit'

import { useErrorAfterInitialTouch } from '../../hooks'
import {
  PanelContentContainer,
  PanelContentHeader,
  PanelContentSubtitle,
  PanelContentTitle,
  PanelContentValueLocked
} from '../styles'

const StartTimeIncrementsLocked = () => (
  <PanelContentContainer section>
    <PanelContentHeader isLocked>
      <PanelContentTitle>
        {I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.title')}
      </PanelContentTitle>
      <PanelContentValueLocked>
        <Increments isLocked v3Style />
      </PanelContentValueLocked>
    </PanelContentHeader>
    <PanelContentSubtitle>
      {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.start_time_increments_description')}
    </PanelContentSubtitle>
  </PanelContentContainer>
)

const StartTimeIncrementsField = () => {
  useValidateOnChange('customSpotStep')
  useErrorAfterInitialTouch('customSpotStep')

  useValidateOnChange('customSpotStepType')

  return (
    <PanelContentContainer section data-testid="start_time_increments_section">
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.scheduling_settings.additional_options.increments.title')}
        </PanelContentTitle>
        <PanelContentSubtitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.limits_and_buffers.start_time_increments_description')}
        </PanelContentSubtitle>
      </PanelContentHeader>
      <PanelContentContainer subsection>
        <BodyText size="medium" color="muted" id="incrementSelectLabel">
          {I18n.t('publisher.event_types.availability.increments_fieldset.increments_title')}
        </BodyText>
        <Increments v3Style />
      </PanelContentContainer>
    </PanelContentContainer>
  )
}

export const StartTimeIncrements = ({ isLocked }) => (
  !isLocked ? <StartTimeIncrementsField /> : <StartTimeIncrementsLocked />
)
